<template>
  <section
    class="list-space-recommend"
    v-for="(item, index) in recommendSpaceRent"
    :key="index"
  >
    <div v-if="item && item?.length" class="recommend-container">
      <h2 class="title-list">
        <span>{{ recommendSpaceTitle[index] }}</span>
      </h2>
      <ListSpace :nameGroupArea="nameGroupArea" :dataList="item" class="listSpace" />
    </div>
  </section>
</template>

<script setup>
/* eslint-disable */
import { ref, watch, inject, onMounted, defineProps } from "vue";
import useStore from "@/client/store/Customer";
import { getGroupAreaRecommendApi } from "@/client/api";
import { useRoute } from "vue-router";
import ListSpace from "@/client/views/ListSpaceOfArea/ListSpace/ListSpace.vue";

const store = useStore();
const recommendSpaceRent = ref([]);
const recommendSpaceTitle = ref([]);
const recommendGroupAreaId = ref("");
const route = useRoute();
const nameGroupAreaSearch = ref();
const idGroupArea = route?.query?.group_area

const props = defineProps({
  researchValue: {
    type: Object,
    default: () => {
      return {
        group_area: "",
        date: "",
        timeStart: "",
        timeEnd: "",
        category: "",
        people: "",
        dateTime: "",
        people_count: {},
      };
    },
  },
  nameGroupArea: {
    type: String,
  }
});

watch(props, ()=>{
  if(props.nameGroupArea) {
    nameGroupAreaSearch.value = props.nameGroupArea
  }
})

watch(store,() => {
  if(!!store?.getListGroupArea) {
    const listGroupArea = Array.from(store.getListGroupArea) || [];
    nameGroupAreaSearch.value = listGroupArea?.find((item) => item.id == idGroupArea)
  }
});

const getGroupAreaRecommend = async (groupAreaId) => {
  try {
    setTimeout(async() => {
      const res = await getGroupAreaRecommendApi(groupAreaId);
      if (res.data && res.data?.length) {
        res.data.forEach(function (element) {
          let recommendSpace = [];
          recommendSpace = element["list"].map((item) => ({
            ...item,
            image_url:
              item.rental_space_image.length != 0
                ? `${item.rental_space_image[0].url_image}`
                : "",
          }));
          recommendSpaceTitle.value.push(element["title"]);
          recommendSpaceRent.value.push(recommendSpace);
        });
      } else {
        recommendSpaceTitle.value = [];
        recommendSpaceRent.value = [];
      }
    }, 3000);
  } catch (errors) {
    recommendSpaceTitle.value = [];
    recommendSpaceRent.value = [];
  } finally {
  }
};

onMounted(async () => {
  if (props.researchValue.group_area) {
    setTimeout(async() => {
      recommendGroupAreaId.value = props.researchValue.group_area;
      await getGroupAreaRecommend(props.researchValue.group_area);
    }, 3000);
  }
});

watch(
  () => route,
  async () => {
    if (
      props.researchValue.group_area &&
      recommendGroupAreaId.value != props.researchValue.group_area
    ) {
      recommendSpaceTitle.value = [];
      recommendSpaceRent.value = [];
      recommendGroupAreaId.value = props.researchValue.group_area;
      await getGroupAreaRecommend(props.researchValue.group_area);
    }
  },
  { deep: true }
);
</script>

<style scoped lang="scss">
@import "./GroupAreaRecommendSpaces.scss";
</style>
